// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".site-card-tag[data-v-d5678b56]{display:inline-block;color:#fff;background:#6d7780;height:24px;border-radius:14px}.site-card-tag__label[data-v-d5678b56]{font-size:10px;line-height:2.4;letter-spacing:.02em;font-weight:600;padding:5px 12px 4px}", ""]);
// Exports
module.exports = exports;
